import { createGlobalStyle } from "styled-components";
export const curtainVisibleClassNamePrefix = "curtain-visible-";
export const GlobalCurtainStyle = createGlobalStyle `
  html[class*="${curtainVisibleClassNamePrefix}"] {
    body {
      overflow: hidden;
      box-sizing: border-box;
      /**
       * Wait a minute, what is that calc() doing here?!
       * Let me try to explain. If the iOS Safari footer is hidden when the curtain
       * opens, iOS will reveal the footer if the user makes a vertical pan 
       * gesture, the 1px prevents this from happening. I don’t know. 🤷‍♂️
       */
      height: calc(var(--window-inner-height) - 1px);
    }
  }
`;
export default GlobalCurtainStyle;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2xvYmFsQ3VydGFpblN0eWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQ3VydGFpbi9zdHlsZWQvR2xvYmFsQ3VydGFpblN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBRXRELE1BQU0sQ0FBQyxNQUFNLDZCQUE2QixHQUFHLGtCQUFrQixDQUFDO0FBRWhFLE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLGlCQUFpQixDQUFBO2lCQUNsQyw2QkFBNkI7Ozs7Ozs7Ozs7Ozs7Q0FhN0MsQ0FBQztBQUVGLGVBQWUsa0JBQWtCLENBQUMifQ==